import React, { memo } from 'react';
import PhoneCallButton from './components/phone';
import Navigation from './components/navigation';
// import MessengerContainer from './components/messenger';
// import AdStickyBanner from './components/banner';

const Container = memo(() => (
  <>
    <Navigation />
    <PhoneCallButton />
    {/* <MessengerContainer /> */}
    {/* <AdStickyBanner /> */}
  </>
));

export default Container;
